import { isApiConfigured } from './api-keys';
import { shouldUseLLMProxy } from '../lib/openai-proxy';

export interface FeatureFlags {
  enableGooglePlaces: boolean;
  enablePlaid: boolean;
  enableGoogleCalendar: boolean;
  enableGeolocation: boolean;
  enableChat: boolean;
  enableBBSPlus: boolean;
  enableSync: boolean;
  // Mission agent flags — disabled when API keys not configured
  enableShoppingAgent: boolean;
  enableRestaurantAgent: boolean;
  enableTravelAgent: boolean;
  enableEventsAgent: boolean;
  enableContentAgent: boolean;
  enableDiagnosticAgent: boolean;
}

export function getFeatureFlags(): FeatureFlags {
  return {
    enableGooglePlaces: isApiConfigured('googlePlaces'),
    enablePlaid: isApiConfigured('plaidEdgeUrl'),
    enableGoogleCalendar: true,  // Uses existing OAuth tokens
    enableGeolocation: true,      // Browser API, no key needed
    enableChat: shouldUseLLMProxy(),
    enableBBSPlus: false,         // Sprint 18
    enableSync: false,            // Sprint 17
    // Mission agents — All agents have LLM fallbacks when external API keys are missing.
    // External API keys improve quality (real data) but aren't required to generate missions.
    enableShoppingAgent: true,    // LLM fallback when no deal provider
    enableRestaurantAgent: true,  // LLM fallback when no Google Places key
    enableTravelAgent: true,      // LLM fallback when no SerpAPI key
    enableEventsAgent: true,      // LLM fallback when no Ticketmaster key
    enableContentAgent: true,     // LLM fallback when no News API key
    enableDiagnosticAgent: true,  // LLM-only, no external API key needed
  };
}
